import {isObject, set} from "lodash-es";
import {IS_PRODUCTION} from "@/settings";
import Vue from 'vue';


/**
 * Set Property
 * Make it reactive if required to make Vue react to changes
 * todo: improve method to support nested properties
 * @param obj
 * @param prop
 * @param value
 * @param makeReactive
 * @param forceReactivity
 * @constructor
 */
export const SET_PROPERTY_OBJECT = ({}, { obj, prop, value, makeReactive = false, forceReactivity = false }) =>
{
    if (!isObject(obj))
        return;

    let propType = typeof prop;
    if (propType !== 'string' && propType !== 'number')
        return;

    if ( (!obj.hasOwnProperty(prop) && makeReactive) || forceReactivity) {
        Vue.set(obj, prop, value); // triggers reactivity on newly set property, slow
        if (!IS_PRODUCTION)
            console.log('reactivity set for: ', obj, prop, forceReactivity); // temp feedback if prop was set via VUE
    }
    else
        obj[prop] = value;
};


/**
 * Update existing Property
 * @param state
 * @param obj
 * @param path
 * @param value
 * @constructor
 */
export const UPDATE_PROPERTY = (state, { obj, path, value }) =>
{
    obj = obj ?? state;
    set(obj, path, value);
};
